export default "__VITE_ASSET__BUyhRnAT__"